import type { ReactNode } from 'react'
import { NavLink } from 'react-router'

const baseClassName =
  'inline-flex min-h-10 items-center justify-center rounded-lg border px-4 py-2 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900'

function linkClassName(isActive: boolean): string {
  return `${baseClassName} ${
    isActive
      ? 'border-sky-700 bg-sky-700 text-white shadow-sm dark:border-sky-500 dark:bg-sky-600'
      : 'border-slate-300 bg-white text-slate-800 shadow-sm hover:border-sky-400 hover:bg-sky-50 hover:text-sky-900 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:hover:border-sky-500 dark:hover:bg-slate-700'
  }`
}

export function FunnelAreaNav(): ReactNode {
  return (
    <nav
      aria-label="Potenzial-Trichter Bereiche"
      className="mb-6 rounded-xl border border-slate-200 bg-slate-100 p-3 dark:border-slate-700 dark:bg-slate-800/70"
    >
      <p className="mb-2 text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-300">
        Bereich wechseln
      </p>
      <div className="flex flex-wrap gap-2">
        <NavLink to="/topics" end className={({ isActive }) => linkClassName(isActive)}>
          Offene Trichter bearbeiten
        </NavLink>
        <NavLink to="/topics/approved" className={({ isActive }) => linkClassName(isActive)}>
          Freigegebene Trichter auswerten
        </NavLink>
      </div>
    </nav>
  )
}
